import {
  FETCH_EXTERNAL_APIS_REQUEST,
  FETCH_EXTERNAL_APIS_SUCCESS,
  FETCH_EXTERNAL_APIS_ERROR,
  UPDATE_EXTERNAL_API_REQUEST,
  UPDATE_EXTERNAL_API_SUCCESS,
  UPDATE_EXTERNAL_API_ERROR,
  TOGGLE_EXTERNAL_API_TARGET_REQUEST,
  TOGGLE_EXTERNAL_API_TARGET_SUCCESS,
  TOGGLE_EXTERNAL_API_TARGET_ERROR,
  RESET_EXTERNAL_APIS,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
    filter: {
      search: '',
      hasPagination: true,
      page: 1,
      size: 10,
    },
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
  },
  togglingIds: [],
}

const externalApisReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_EXTERNAL_APIS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true,
          error: null,
        },
      }

    case FETCH_EXTERNAL_APIS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          records: action.payload,
          filter: action.filter,
          isFetching: false,
          error: null,
        },
      }

    case FETCH_EXTERNAL_APIS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          records: [],
          isFetching: false,
          error: action.payload,
        },
      }

    case UPDATE_EXTERNAL_API_REQUEST:
      return {
        ...state,
        edit: {
          ...state.edit,
          isUpdating: true,
          error: null,
        },
      }

    case UPDATE_EXTERNAL_API_SUCCESS:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: action.payload,
          isUpdating: false,
          error: null,
        },
      }

    case UPDATE_EXTERNAL_API_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          record: {},
          isUpdating: false,
          error: action.payload,
        },
      }

    case TOGGLE_EXTERNAL_API_TARGET_REQUEST:
      return {
        ...state,
        togglingIds: state.togglingIds.includes(action.id)
          ? state.togglingIds
          : [...state.togglingIds, action.id],
      }

    case TOGGLE_EXTERNAL_API_TARGET_SUCCESS:
      return {
        ...state,
        togglingIds: state.togglingIds.filter((id) => id !== action.id),
      }

    case TOGGLE_EXTERNAL_API_TARGET_ERROR:
      return {
        ...state,
        togglingIds: state.togglingIds.filter((id) => id !== action.id),
        edit: {
          ...state.edit,
          error: action.payload,
        },
      }

    case RESET_EXTERNAL_APIS:
      return {
        ...state,
        list: {
          ...state.list,
          records: [],
          error: null,
          isFetching: false,
        },
        edit: {
          record: {},
          error: null,
          isUpdating: false,
        },
        togglingIds: [],
      }

    default:
      return state
  }
}

export default externalApisReducer
